import React from "react"
import { graphql, Link } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Hero from "../components/hero"
import Section from "../components/section"
import CoursesCategories from "../components/coursesCategories"
import ImageTextSectionCourses from "../components/imageTextSectionCourses"
import GeniusSection from "../components/geniusSection"

export const query = graphql`
  query {
    sanityGenericCourses {
      title
      _rawDescription
      _rawBody(resolveReferences: { maxDepth: 10 })
      genius
      datePublished: _createdAt
      dateModified: _updatedAt
      categories {
        id
        title
        color
        description
        _rawThumbnail(resolveReferences: { maxDepth: 2 })
        slug {
          current
        }
      }
      seo {
        metaTitle
        canonical
        description
        noIndex
        openGraphImage {
          asset {
            url
          }
        }
      }
    }
    sanityGenius {
      title
      color
      description
      _rawThumbnail(resolveReferences: { maxDepth: 2 })
    }
  }
`

const GenericCourses = ({ data, path }) => {
  const page = data.sanityGenericCourses
  const genius = data.sanityGenius

  return (
    <Layout>
      <SEO
        title={page.title}
        datePublished={page.datePublished}
        dateModified={page.dateModified}
        {...page.seo}
      />
      <Hero
        title={page.title}
        theme="course-"
        description={page._rawDescription}
      >
        <p>
          <Link to="/">Home</Link> <Link to={path}>{page.title}</Link>
        </p>
      </Hero>
      <Section theme="brandGamma" bg="light" sectionTitle="Explore the Academy">
        <div className="grid">
          <div className="gridItem">
            <CoursesCategories
              categories={page.categories}
              genius={genius}
              displayGenius={page.genius}
            />
          </div>
        </div>
      </Section>
      {page._rawBody.map((section, i) =>
        section._type === "imageTextSectionCourses" ? (
          <ImageTextSectionCourses {...section} key={section._key} />
        ) : (
          <GeniusSection {...section} key={section._key} />
        )
      )}
    </Layout>
  )
}

export default GenericCourses
